.button {
  font-size: 14px;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  display: flex;
  cursor: pointer;
  border-radius: 3px;
  padding: 8px 16px;
}
.button.primary {
  background-color: var(--ogm-mavericks);
  color: var(--ogm-black);
}
.button.primary:hover {
  background-color: var(--ogm-primary-hover);
}
.button.default {
  background-color: var(--ogm-mavericks);
  color: var(--ogm-timberwolves);
}
.button.default:hover {
  background-color: var(--ogm-seahawks);
}
.button.default:disabled {
  color: var(--ogm-grizzlies);
}
.button.default:disabled:hover {
  background-color: var(--ogm-mavericks);
}
.button.secondary {
  background-color: var(--ogm-seahawks);
  color: var(--ogm-timberwolves);
}
.button.secondary:hover {
  color: var(--ogm-white);
  background-color: var(--ogm-bucks);
}
.button.secondary:disabled {
  color: var(--ogm-bucks);
}
.button.secondary:disabled:hover {
  background-color: var(--ogm-seahawks);
}
.button.secondary-new {
  background-color: var(--ogm-timberwolves);
  color: var(--ogm-white);
}
.button.secondary-new:hover {
  color: var(--ogm-seahawks);
}
.button.secondary-new:disabled {
  color: var(--ogm-grizzlies);
}
.button.action {
  border: solid 1px var(--ogm-pelicans);
  color: var(--ogm-pelicans);
  font-weight: 800;
}
.button.drifting {
  background-color: var(--ogm-mavericks);
  color: black;
}
.button.shortening {
  background-color: var(--ogm-mavericks);
  color: black;
}
.button.oval {
  border-radius: 20px;
}
.button.square {
  padding: 0;
}
.button.round {
  border-radius: 50%;
}
.button.toggle {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  vertical-align: middle;
  white-space: nowrap;
  color: var(--ogm-seahawks);
  box-sizing: border-box;
}
.button.no-padding {
  padding: 0;
}
